import { ThemeProvider } from "next-themes"
import NextTopLoader from "nextjs-toploader"
import { BreakpointIndicator } from "@/components/misc/breakpoint-indicator"
import { Toaster } from "@/components/ui/sonner"
import { TooltipProvider } from "@/components/ui/tooltip"
import "@/styles/globals.css"
import { GoogleTagManager } from "@next/third-parties/google"
import { Provider as JotaiProvider } from "jotai"
import type { Locale } from "next-intl"
import { NuqsAdapter } from "nuqs/adapters/next/app"
import { env } from "@/env/server"
import { AffonsoScript } from "@/lib/polar/affonso-script"
import { PostHogProvider } from "@/lib/posthog/provider"
import { fontStyles } from "@/styles/fonts"
import { cn } from "@/utils/cn"

type Theme = "light" | "dark"

interface RootLayoutProps {
  children: React.ReactNode
  locale: Locale
  forcedTheme?: Theme
  defaultTheme?: Theme | "system"
  themes?: Theme[]
  enableSystem?: boolean
}
export default function RootLayout({
  children,
  locale,
  forcedTheme,
  defaultTheme = "system",
  themes = ["light", "dark"],
  enableSystem = true,
}: RootLayoutProps) {
  return (
    <html lang={locale} dir="ltr" className={cn(fontStyles)} suppressHydrationWarning>
      <body className="relative flex h-full min-h-screen flex-col">
        <PostHogProvider>
          <JotaiProvider>
            <NuqsAdapter>
              <ThemeProvider
                attribute="class"
                forcedTheme={forcedTheme}
                defaultTheme={defaultTheme}
                themes={themes}
                enableSystem={enableSystem}
                disableTransitionOnChange
              >
                <NextTopLoader color="var(--primary)" height={2} showSpinner={false} />
                <Toaster position="top-right" closeButton richColors />

                <TooltipProvider>{children}</TooltipProvider>

                <BreakpointIndicator />
              </ThemeProvider>
            </NuqsAdapter>
          </JotaiProvider>
        </PostHogProvider>

        {/* Affonso (Affiliate Program) */}
        {env.NEXT_PUBLIC_PRODUCTION_MODE && <AffonsoScript />}

        {/* Google Tag Manager (Google Ads) */}
        {env.NEXT_PUBLIC_PRODUCTION_MODE && <GoogleTagManager gtmId="AW-17145086695" />}
      </body>
    </html>
  )
}
